// src/MatchResultModalV2.jsx
import React from "react";
import { useTranslation } from "react-i18next";


function localizeStageLabel(raw, translate) {
  const label = String(raw || '').trim();
  const value = label.toLowerCase();

  if (!label) return '';
  if (value.includes('полу') || value.includes('semi')) {
    return translate('jackpotBoard.stage.semifinal');
  }
  if (value.includes('финал') || value.includes('final')) {
    return translate('jackpotBoard.stage.final');
  }
  if (value.includes('квалиф') || value.includes('qualif')) {
    return translate('jackpotBoard.stage.qualification');
  }
  if (value.includes('rebuy')) {
    return translate('jackpotBoard.stage.rebuy');
  }

  return label;
}

/** Мини-брекет (2 раунда: полуфиналы → финал) */
function BracketMini({ rounds = [] }) {
  const { t: translate } = useTranslation();
  if (!rounds?.length) return null;

  return (
    <div className="brkt">
      {rounds.map((round, idx) => (
        <div className="brkt-col" key={idx}>
          <div className="brkt-col__title">{localizeStageLabel(round.label, translate)}</div>

          <div className="brkt-col__list">
            {round.matches?.map((m, i) => {
              const a = m?.a ?? "—";
              const b = m?.b ?? "—";
              const winner = m?.winner ?? null;

              return (
                <div className="brkt-match" key={i} aria-label={`${a} vs ${b}`}>
                  <div
                    className={
                      "brkt-seed " +
                      (winner
                        ? winner === a
                          ? "brkt-seed--win"
                          : "brkt-seed--lose"
                        : "brkt-seed--pending")
                    }
                  >
                    <span className="brkt-seed__dot" />
                    <span className="brkt-seed__name">{a}</span>
                  </div>

                  <div
                    className={
                      "brkt-seed " +
                      (winner
                        ? winner === b
                          ? "brkt-seed--win"
                          : "brkt-seed--lose"
                        : "brkt-seed--pending")
                    }
                  >
                    <span className="brkt-seed__dot" />
                    <span className="brkt-seed__name">{b}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}



/** Автозаполнение финала победителями полуфиналов */
const fillFinalFromSemis = (rounds = []) => {
  const semis = rounds.find(r =>
    String(r.label).toLowerCase().includes("полуфин")
  );
  const final = rounds.find(r => {
    const l = String(r.label).toLowerCase();
    // исключаем "полуфинал", т.к. содержит подстроку "финал"
    return l.includes("финал") && !l.includes("полуфин");
  });

  if (!semis || !final) return rounds;

  const winners = (semis.matches || [])
    .map(m => m?.winner)
    .filter(Boolean);

  const currentFinal =
    final.matches?.[0] || { a: "—", b: "—", winner: undefined };

  // ✅ корректно формируем слоты финала
  const [first, second] = winners;

  // первый слот финала — победитель первой пары
  const a = first || currentFinal.a || "—";

  // второй слот финала — победитель второй пары, если он уже есть
  // если его нет, ставим прочерк, даже если первый слот занят тем же именем
  const b = second ? second : "—";

  const filledFinal = {
    a,
    b,
    winner: currentFinal.winner ?? undefined,
  };

  // заменяем только финальный раунд
  return rounds.map(r => (r === final ? { ...r, matches: [filledFinal] } : r));
};

// const fillFinalFromSemis = (rounds = []) => {
//   const semis = rounds.find(r =>
//     String(r.label).toLowerCase().includes("полуфин")
//   );
//   const final = rounds.find(r => {
//     const l = String(r.label).toLowerCase();
//     // исключаем "полуфинал", т.к. содержит подстроку "финал"
//     return l.includes("финал") && !l.includes("полуфин");
//   });

//   if (!semis || !final) return rounds;

//   const winners = (semis.matches || [])
//     .map(m => m?.winner)
//     .filter(Boolean);

//   const currentFinal =
//     final.matches?.[0] || { a: "—", b: "—", winner: undefined };

//   const filledFinal = {
//     a: winners[0] || currentFinal.a || "—",
//     b: winners[1] || currentFinal.b || "—",
//     winner: currentFinal.winner ?? undefined,
//   };

//   return rounds.map(r => (r === final ? { ...r, matches: [filledFinal] } : r));
// };

export default function MatchResultModalV2({
  show = false,
  outcome = {},       // { winner, loser, isFinal, reason }
  message = "",
  prize = null,
  stageLabel = "",
  currentUser = "",
  bracketRounds = [], // массив rounds как в описании выше
  onClose = () => {},
  onPrimary = () => {},
}) {
  const { t: translate } = useTranslation();

  // Хук вызываем БЕЗУСЛОВНО
  const roundsFilled = React.useMemo(
    () => fillFinalFromSemis(bracketRounds || []),
    [bracketRounds]
  );

  if (!show) return null;

  const lsUser =
    (typeof window !== "undefined" && localStorage.getItem("username")) || "";
  const me = currentUser || lsUser;

  const isWinner = outcome?.winner && me && outcome.winner === me;
  const isLoser = outcome?.loser && me && outcome.loser === me;
  const isFinal = !!outcome?.isFinal;

  const variant = isWinner ? "win" : isLoser ? "lose" : "neutral";
  const bigIcon = isWinner ? "🏆" : isLoser ? "💔" : "🎯";

  const reason = outcome?.reason;
  const reasonText =
    reason === 'timeout'
      ? translate('jackpotBoard.modalReasonTimeout')
      : reason === 'surrender'
      ? translate('jackpotBoard.modalReasonSurrender')
      : '';

  const title = isWinner
    ? isFinal
      ? translate('jackpotBoard.modalChampion')
      : translate('jackpotBoard.modalVictory')
    : isLoser
    ? isFinal
      ? translate('jackpotBoard.modalFinalLost')
      : translate('jackpotBoard.modalDefeat')
    : isFinal
    ? translate('jackpotBoard.modalFinalFinished')
    : translate('jackpotBoard.modalMatchFinished');





    
  return (
    <div className="tbd-overlay" onClick={onClose}>
      <div
        className={`tbd tbd--${variant}`}
        onClick={e => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <div className="tbd-ribbon" aria-hidden />

        <aside className="tbd-hero">
          <div className="tbd-hero__icon" aria-hidden>
            {bigIcon}
          </div>
          {stageLabel && (
            <div className="tbd-hero__stage">
              {localizeStageLabel(stageLabel, translate)}
            </div>
          )}
          <h3 className="tbd-hero__title">
            {title}
            {outcome?.winner && isFinal && isWinner && (
              <span className="tbd-hero__title-name"> {outcome.winner}</span>
            )}
          </h3>
          {!!reasonText && <div className="tbd-chip">{reasonText}</div>}

          {isFinal && isWinner && prize != null ? (
            <div className="tbd-prize tbd-prize--pop">
              <span className="tbd-prize__icon"></span>
          <span className="tbd-prize__label22">{translate('jackpotBoard.prize')}: $</span>
         <b className="tbd-prize__value">{String(prize)}</b>
            </div>
          ) : null}
        </aside>

        <section className="tbd-body">
          {message && <p className="tbd-msg">{message}</p>}

          {/* Мини-брекет: победители зелёные, проигравшие красные */}
          <BracketMini rounds={roundsFilled} />

          <div className="tbd-vs">
            {outcome?.winner && (
              <div className="tbd-vs__item tbd-vs__item--win">
                <span className="tbd-vs__label">{translate('jackpotBoard.winner')}</span>
                <span className="tbd-vs__name">🥇 {outcome.winner}</span>
              </div>
            )}
            {outcome?.loser && (
              <div className="tbd-vs__item tbd-vs__item--lose">
                <span className="tbd-vs__label">{translate('jackpotBoard.loser')}</span>
                <span className="tbd-vs__name">🥈 {outcome.loser}</span>
              </div>
            )}
          </div>

          <div className="tbd-actions">
            <button className="tbd-btn tbd-btn--primary" onClick={onPrimary}>
              {translate('jackpotBoard.lobby')}
            </button>
          </div>
        </section>

        <button className="tbd-close" onClick={onClose} aria-label={translate('jackpotBoard.close')}>
          ✕
        </button>
      </div>
    </div>
  );
}
